import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { validationLabels } from './validation-label-map';

@Component({
    selector: 'asap-forms-validation-summary',
    templateUrl: './validation-summary.html',
    styleUrls: ['./validation-summary.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'asap-forms-validation-summary',
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormsValidationSummaryComponent implements OnChanges {
    errors: string[] = [];
    labels = validationLabels;
    title = 'Required fields';

    @Input() public form: FormGroup;
    @Input() public listToValidate: any;
    @Input() public page: string;
    @Input() public isrequird: boolean = true;
    @Input() public additionalErrors?: string[] = [];
    @Input() public isCustom = false;
    @Input() public customValidation: any = [];
    @Input() public customFields: any = [];

    constructor(
    ) { }

    ngOnInit(): void {

        if(this.isCustom){
          this.title = "Required Custom Fields";
        }

        this.generateErrorMessages();

        this.form.statusChanges.subscribe(() => {
            this.resetErrorMessages();
            this.generateErrorMessages();
        });
    }

    ngOnChanges(changes: SimpleChanges) {

        if (changes.additionalErrors) {
            this.resetErrorMessages();
            this.generateErrorMessages();
        }
        else if (!changes.form?.firstChange) {
            this.resetErrorMessages();
            this.generateErrorMessages();
        }
    }

    resetErrorMessages(): void {
        this.errors.length = 0;
    }

    generateErrorMessages(): void {

        if (this.page == "customReport") {
            if (!this.listToValidate || this.listToValidate.length == 0) {
                this.errors.push(`selected fields list is empty`);
            }
        }
        if (!(this.page == "customReport") || this.form) {
          if(!this.isCustom)
          {
            let controlNames = Object.keys(this.form.controls);
            controlNames.forEach(controlName => {
                let control = this.form.controls[controlName];
                let errors = control.errors;
                let message = this.labels[this.page]?.[controlName]  ? this.labels[this.page][controlName] : controlName;

                if(!this.isrequird) this.title = ' ' ;

                if (errors === null || errors.length === 0) {
                    return;
                }

                if (errors.required && this.isrequird ) {
                    this.errors.push(`${message}`);
                }

                 if (errors.min) {
                    this.errors.push(`${message} minimum is ${errors.min.min}.`);
                }

                if (errors.max) {
                    this.errors.push(`${message} maximum is ${errors.max.max}`)
                }

                if (errors.minlength) {
                    this.errors.push(`${message} minimum length is ${errors.minlength.requiredLength}.`);
                }

                if (errors.maxError && !this.labels[this.page][controlName]) {
                    this.errors.push(`${message} maximum length is ${errors.maxError.maxValue}`)
                }
                else if (errors.maxError) {
                    this.errors.push(`${message}`);
                }

                if (errors.email) {
                    this.errors.push(`${message} is not a valid email`);
                }

            });
          }

        }
        if (this.customFields) {
            this.customValidation.forEach((customfield: any) => {
                let message = `${customfield.name} <span class=\"asap-error-message-description\">(Go To ${customfield.tabName})</span>`;

                if (customfield.value == '' || customfield.value == undefined) {
                    this.errors.push(`${message}`);
                }
            });
        }

        if (this.additionalErrors.length > 0) {
            this.additionalErrors.forEach(err => {
                this.errors.push(err);
            })
        }

        this.cleanErrorsList();
    }

    cleanErrorsList() {
        this.errors = this.errors.filter((err, pos) => this.errors.indexOf(err) === pos)
    }
}
